import { render, staticRenderFns } from "./SysTiposProdutoAutocomplete.vue?vue&type=template&id=21c439ee"
import script from "./SysTiposProdutoAutocomplete.vue?vue&type=script&lang=js"
export * from "./SysTiposProdutoAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports